module.exports = __webpack_public_path__ + "Roboto-regular.38861cba61c66739c145.ttf";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src590146077/src/src/assets/fonts/roboto/fonts/Roboto-regular/Roboto-regular.ttf
// module id = ../../../../../src/assets/fonts/roboto/fonts/Roboto-regular/Roboto-regular.ttf
// module chunks = main styles